import { PageConfig } from './pageConfigTs';

export const PAGE_CONFIG: PageConfig = {
  title: 'Revenue',
  titleCN: '付费流水',
  subTitle: '',
  subTitleCN: '',
  path: '/monetization/revenue',
  defaultTab: 'revenue',
  tabList: [
    {
      id: 'revenue',
      tabName: 'Revenue',
      tabNameCN: '付费流水',
      isHaveNotification: true,
      path: '/monetization/revenue',
      logConfig: {
        pageId: '201401',
        pageName: 'monetizationRevenue',
        extInfo: 'monetizationRevenue',
        pagePath: '/monetization/revenue'
      },
      filters: [
        {
          name: 'RevenueFilterNewCo',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/monetization/revenue',
          componentList: [
            {
              name: 'MonetizationRevenueTrendCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/monetization/revenue/metrics',
                  dataKey: 'MonetizationRevenueData'
                }
              },
              children: [
                {
                  name: 'CommonRow',
                  className: '',
                  type: 'layout',
                  style: {},
                  props: {},
                  children: [
                    {
                      name: 'CommonCol',
                      className: 'margin-t-20',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 12
                      },
                      enName: 'Revenue($)',
                      cnName: '付费金额($)',
                      defaultActive: 1,
                      children: [
                        {
                          name: 'RevenueCo',
                          className: '',
                          style: {},
                          type: 'view',
                          props: {
                            config: {
                              componentMetricsConfig: [
                                {
                                  metricKey: 'revenue',
                                  enName: 'Revenue($)',
                                  cnName: '付费金额($)',
                                  isPercent: false,
                                  decimal: 2,
                                  type: 'decimals'
                                },
                                {
                                  metricKey: 'dau',
                                  enName: 'ARPPU($)',
                                  cnName: '日活跃',
                                  isPercent: false,
                                  decimal: 2,
                                  type: 'int'
                                },
                                {
                                  metricKey: 'arppu',
                                  enName: 'ARPPU($)',
                                  cnName: '付费ARPPU($)',
                                  isPercent: false,
                                  decimal: 2,
                                  type: 'decimals'
                                },
                                {
                                  metricKey: 'payer_ratio',
                                  enName: 'Payer%',
                                  cnName: '付费渗透率',
                                  isPercent: true,
                                  decimal: 2,
                                  type: 'percent'
                                }
                              ]
                            }
                          },
                          children: []
                        }
                      ]
                    },
                    {
                      name: 'CommonCol',
                      className: 'margin-t-20',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 12
                      },
                      enName: 'ARPU & ARPPU',
                      cnName: '活跃ARPU & 付费ARPPU',
                      defaultActive: 2,
                      children: [
                        {
                          name: 'RevenueMetricsTrendsCo',
                          className: '',
                          style: {},
                          type: 'view',
                          props: {
                            config: {
                              chart: {
                                type: 'decimals',
                                isPercent: false,
                                decimal: 2
                              },
                              componentMetricsConfig: [
                                {
                                  metricKey: 'arpu',
                                  enName: 'ARPU($)',
                                  cnName: '活跃ARPU($)',
                                  isPercent: false,
                                  decimal: 2,
                                  type: 'decimals',
                                  isDeleteChartTipsDollar: true
                                },
                                {
                                  metricKey: 'arppu',
                                  enName: 'ARPPU($)',
                                  cnName: '付费ARPPU($)',
                                  isPercent: false,
                                  decimal: 2,
                                  type: 'decimals',
                                  isDeleteChartTipsDollar: true
                                }
                              ]
                            }
                          },
                          children: []
                        }
                      ]
                    }
                  ]
                },
                {
                  name: 'CommonRow',
                  className: 'margin-b-10 margin-t-10',
                  type: 'layout',
                  style: {},
                  props: {},
                  children: [
                    {
                      name: 'CommonCol',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 12
                      },
                      enName: 'Payer And Payer%',
                      cnName: '付费人数&付费渗透率',
                      defaultActive: 1,
                      children: [
                        {
                          name: 'PayerAndPayerCo',
                          className: '',
                          style: {},
                          type: 'view',
                          props: {
                            config: {
                              componentMetricsConfig: [
                                {
                                  metricKey: 'mtx_payers',
                                  enName: 'Payer',
                                  cnName: '付费人数',
                                  isPercent: false,
                                  decimal: 2,
                                  type: 'int'
                                },
                                {
                                  metricKey: 'mtx_payer_rate',
                                  enName: 'Payer%',
                                  cnName: '付费渗透率',
                                  isPercent: true,
                                  decimal: 2,
                                  type: 'percent'
                                }
                              ]
                            }
                          },
                          children: []
                        }
                      ]
                    },
                    {
                      name: 'CommonCol',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 12
                      },
                      enName: 'Revenue Channel Distribution',
                      cnName: '付费金额登录渠道构成',
                      defaultActive: 1,
                      children: [
                        {
                          name: 'RevenueChannelDistributionCo',
                          className: '',
                          style: {},
                          type: 'view',
                          props: {
                            config: {
                              chart: {
                                type: 'decimals',
                                isPercent: false,
                                decimal: 2
                              }
                            }
                          },
                          children: []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              name: 'CommonRow',
              type: 'layout',
              style: {},
              props: {},
              className: '',
              children: [
                {
                  name: 'RankListTabCo',
                  className: undefined,
                  style: {
                    margin: '-10px',
                    position: 'relative',
                    left: '10px'
                  },
                  props: {},
                  type: 'view',
                  data: {
                    regionDataType: 'country',
                    tabOrder: ['country', 'region', 'zone']
                  },
                  children: [
                    {
                      name: 'CommonCol',
                      className: 'margin-b-10',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 24
                      },
                      children: [
                        {
                          name: 'MonetizationRevenueTrendCo',
                          className: '',
                          type: 'view',
                          style: {},
                          props: {
                            config: {
                              api: '/api/v1/dashboard/monetization/revenue/countries_region_zone',
                              isSegmentFilter: true,
                              dataKey: 'MonetizationRankData'
                            }
                          },
                          children: [
                            {
                              name: 'RevenueBreakdownCo',
                              className: '',
                              style: {},
                              type: 'view',
                              props: {
                                config: {},
                                defaultActive: 1,
                                metricsEnName: 'Revenue($)',
                                ratioEnName: 'Share',
                                metricsChName: '付费金额($)',
                                ratioChName: '占比',
                                isHaveBar: true,
                                isHaveLine: true,
                                isHavePie: true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              name: 'OverallTableCo',
              className: 'margin-t-20',
              type: 'view',
              style: {},
              props: {
                config: {
                  isHaveDiff: false,
                  showStatistic: ['sum', 'avg'],
                  pageSizeOptions: [10, 20, 30, 40, 50],
                  slotConfig: {
                    isShowdownloadConfig: false,
                    isShowValueType: false,
                    isShowMetricsSettings: false,
                    isShowProgressBar: false,
                    defaultProgressVisible: false
                  },
                  valueTypeConfig: {
                    valueType: 'dod',
                    isShowChange: false
                  },
                  dimensionConfig: {
                    defaultAccumulation: ['date'],
                    isShowCountryFlag: false,
                    dateDisable: true,
                    isRevenueCustomAccumulate: true
                  },
                  api: {
                    tableApi: '/api/v1/dashboard/monetization/revenue/overall_performance',
                    tableDownloadApi: '/api/v1/dashboard/monetization/revenue/performance/download'
                  },
                  titleEn: 'Overall Payment',
                  titleCn: '总体付费表现',
                  componentMetricsConfig: {
                    Day: [
                      {
                        metricKey: 'total_pay_amount',
                        reqMetricKey: 'total_pay_amount',
                        enPercentWidth: 180,
                        cnPercentWidth: 180,
                        enWidth: 105,
                        cnWidth: 112,
                        enName: 'Total Revenue($)',
                        cnName: '总付费金额($)',
                        rainbowKey: 'Total Revenue($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'pay_amount',
                        reqMetricKey: 'pay_amount',
                        enPercentWidth: 180,
                        cnPercentWidth: 180,
                        enWidth: 180,
                        cnWidth: 180,
                        enName: 'Revenue($)',
                        cnName: '付费金额($)',
                        rainbowKey: 'Revenue($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'active_users',
                        reqMetricKey: 'active_users',
                        enWidth: 180,
                        cnWidth: 180,
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enName: 'DAU',
                        cnName: '日活跃',
                        rainbowKey: 'DAU',
                        type: 'int',
                        decimal: 0,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'arppu',
                        reqMetricKey: 'arppu',
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enWidth: 180,
                        cnWidth: 180,
                        enName: 'ARPPU($)',
                        cnName: '付费ARPPU($)',
                        rainbowKey: 'ARPPU($)',
                        type: 'decimals',
                        decimal: 1,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'arpu',
                        reqMetricKey: 'arpu',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'ARPU($)',
                        cnName: '活跃ARPU($)',
                        rainbowKey: 'ARPU($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'paid_users',
                        reqMetricKey: 'paid_users',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'Payer',
                        cnName: '付费人数',
                        rainbowKey: 'Payer',
                        type: 'int',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'payer_rate',
                        reqMetricKey: 'payer_rate',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'Payer%',
                        cnName: '付费渗透率',
                        rainbowKey: 'Payer%',
                        type: 'percent',
                        isUserType: false,
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'arpp',
                        reqMetricKey: 'arpp',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 160,
                        cnWidth: 160,
                        enName: 'ARPP',
                        cnName: '单次付费收益',
                        rainbowKey: 'ARPP',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_payer_rate',
                        reqMetricKey: 'new_payer_rate',
                        enPercentWidth: 220,
                        cnPercentWidth: 220,
                        enWidth: 260,
                        cnWidth: 260,
                        enName: 'Payer%(new users)',
                        cnName: '付费渗透率（新进用户）',
                        rainbowKey: 'Payer%(new users)',
                        type: 'percent',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_paid_users',
                        reqMetricKey: 'new_paid_users',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'First-time Payer',
                        cnName: '首次付费用户',
                        rainbowKey: 'First-time Payer',
                        type: 'int',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_pay_amount',
                        reqMetricKey: 'new_pay_amount',
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enWidth: 320,
                        cnWidth: 320,
                        enName: 'Revenue(first-time payer)',
                        cnName: '首次付费用户金额',
                        rainbowKey: 'Revenue(first-time payer)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_arppu',
                        reqMetricKey: 'new_arppu',
                        enPercentWidth: 230,
                        cnPercentWidth: 230,
                        enWidth: 286,
                        cnWidth: 286,
                        enName: 'First-time Payer ARPPU($)',
                        cnName: '首次付费用户ARPPU($)',
                        rainbowKey: 'First-time Payer ARPPU($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_user_arpu',
                        reqMetricKey: 'new_user_arpu',
                        enPercentWidth: 230,
                        cnPercentWidth: 230,
                        enWidth: 260,
                        cnWidth: 260,
                        rainbowKey: 'New User ARPU($)',
                        enName: 'New User ARPU($)',
                        cnName: '新进用户付费ARPU($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'total_pay_days',
                        reqMetricKey: 'total_pay_days',
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enWidth: 195,
                        cnWidth: 195,
                        enName: 'Total Pay Days',
                        cnName: '总付费天数',
                        rainbowKey: 'Total Pay Days',
                        type: 'int',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: '30d_ltv',
                        reqMetricKey: '30d_ltv',
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enWidth: 200,
                        cnWidth: 200,
                        enName: 'LTV30',
                        cnName: '30天LTV',
                        rainbowKey: 'LTV30',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: '180d_ltv',
                        reqMetricKey: '180d_ltv',
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enWidth: 200,
                        cnWidth: 200,
                        enName: 'LTV180',
                        cnName: '180天LTV',
                        rainbowKey: 'LTV180',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      }
                    ],
                    Week: [
                      {
                        metricKey: 'total_pay_amount',
                        reqMetricKey: 'total_pay_amount',
                        enPercentWidth: 180,
                        cnPercentWidth: 180,
                        enWidth: 105,
                        cnWidth: 112,
                        enName: 'Total Revenue($)',
                        cnName: '总付费金额($)',
                        rainbowKey: 'Total Revenue($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'pay_amount',
                        reqMetricKey: 'pay_amount',
                        enPercentWidth: 180,
                        cnPercentWidth: 180,
                        enWidth: 180,
                        cnWidth: 180,
                        enName: 'Revenue($)',
                        cnName: '付费金额($)',
                        rainbowKey: 'Revenue($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'active_users',
                        reqMetricKey: 'active_users',
                        enWidth: 180,
                        cnWidth: 180,
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enName: 'WAU',
                        cnName: '周活跃',
                        rainbowKey: 'WAU',
                        type: 'int',
                        decimal: 0,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'arppu',
                        reqMetricKey: 'arppu',
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enWidth: 180,
                        cnWidth: 180,
                        enName: 'ARPPU($)',
                        cnName: '付费ARPPU($)',
                        rainbowKey: 'ARPPU($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'arpu',
                        reqMetricKey: 'arpu',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'ARPU($)',
                        cnName: '活跃ARPU($)',
                        rainbowKey: 'ARPU($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'paid_users',
                        reqMetricKey: 'paid_users',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'Payer',
                        cnName: '付费人数',
                        rainbowKey: 'Payer',
                        type: 'int',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'payer_rate',
                        reqMetricKey: 'payer_rate',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'Payer%',
                        cnName: '付费渗透率',
                        rainbowKey: 'Payer%',
                        type: 'percent',
                        isUserType: false,
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'arpp',
                        reqMetricKey: 'arpp',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 160,
                        cnWidth: 160,
                        enName: 'ARPP',
                        cnName: '单次付费收益',
                        rainbowKey: 'ARPP',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_payer_rate',
                        reqMetricKey: 'new_payer_rate',
                        enPercentWidth: 220,
                        cnPercentWidth: 220,
                        enWidth: 260,
                        cnWidth: 260,
                        enName: 'Payer%(new users)',
                        cnName: '付费渗透率（新进用户）',
                        rainbowKey: 'Payer%(new users)',
                        type: 'percent',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_paid_users',
                        reqMetricKey: 'new_paid_users',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'First-time Payer',
                        cnName: '首次付费用户',
                        rainbowKey: 'First-time Payer',
                        type: 'int',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_pay_amount',
                        reqMetricKey: 'new_pay_amount',
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enWidth: 320,
                        cnWidth: 320,
                        enName: 'Revenue(first-time payer)',
                        cnName: '首次付费用户金额',
                        rainbowKey: 'Revenue(first-time payer)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_arppu',
                        reqMetricKey: 'new_arppu',
                        enPercentWidth: 230,
                        cnPercentWidth: 230,
                        enWidth: 286,
                        cnWidth: 286,
                        enName: 'First-time Payer ARPPU($)',
                        cnName: '首次付费用户ARPPU($)',
                        rainbowKey: 'First-time Payer ARPPU($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_user_arpu',
                        reqMetricKey: 'new_user_arpu',
                        enPercentWidth: 230,
                        cnPercentWidth: 230,
                        enWidth: 260,
                        cnWidth: 260,
                        rainbowKey: 'New User ARPU($)',
                        enName: 'New User ARPU($)',
                        cnName: '新进用户付费ARPU($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'total_pay_days',
                        reqMetricKey: 'total_pay_days',
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enWidth: 195,
                        cnWidth: 195,
                        enName: 'Total Pay Days',
                        cnName: '总付费天数',
                        rainbowKey: 'Total Pay Days',
                        type: 'int',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      }
                    ],
                    Month: [
                      {
                        metricKey: 'total_pay_amount',
                        reqMetricKey: 'total_pay_amount',
                        enPercentWidth: 180,
                        cnPercentWidth: 180,
                        enWidth: 105,
                        cnWidth: 112,
                        enName: 'Total Revenue($)',
                        cnName: '总付费金额($)',
                        rainbowKey: 'Total Revenue($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'pay_amount',
                        reqMetricKey: 'pay_amount',
                        enPercentWidth: 180,
                        cnPercentWidth: 180,
                        enWidth: 180,
                        cnWidth: 180,
                        enName: 'Revenue($)',
                        cnName: '付费金额($)',
                        rainbowKey: 'Revenue($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'active_users',
                        reqMetricKey: 'active_users',
                        enWidth: 180,
                        cnWidth: 180,
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enName: 'MAU',
                        cnName: '月活跃',
                        rainbowKey: 'MAU',
                        type: 'int',
                        decimal: 0,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'arppu',
                        reqMetricKey: 'arppu',
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enWidth: 180,
                        cnWidth: 180,
                        enName: 'ARPPU($)',
                        cnName: '付费ARPPU($)',
                        rainbowKey: 'ARPPU($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'arpu',
                        reqMetricKey: 'arpu',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'ARPU($)',
                        cnName: '活跃ARPU($)',
                        rainbowKey: 'ARPU($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'paid_users',
                        reqMetricKey: 'paid_users',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'Payer',
                        cnName: '付费人数',
                        rainbowKey: 'Payer',
                        type: 'int',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'payer_rate',
                        reqMetricKey: 'payer_rate',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'Payer%',
                        cnName: '付费渗透率',
                        rainbowKey: 'Payer%',
                        type: 'percent',
                        isUserType: false,
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'arpp',
                        reqMetricKey: 'arpp',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 160,
                        cnWidth: 160,
                        enName: 'ARPP',
                        cnName: '单次付费收益',
                        rainbowKey: 'ARPP',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_payer_rate',
                        reqMetricKey: 'new_payer_rate',
                        enPercentWidth: 220,
                        cnPercentWidth: 220,
                        enWidth: 260,
                        cnWidth: 260,
                        enName: 'Payer%(new users)',
                        cnName: '付费渗透率（新进用户）',
                        rainbowKey: 'Payer%(new users)',
                        type: 'percent',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_paid_users',
                        reqMetricKey: 'new_paid_users',
                        enPercentWidth: 150,
                        cnPercentWidth: 150,
                        enWidth: 150,
                        cnWidth: 150,
                        enName: 'First-time Payer',
                        cnName: '首次付费用户',
                        rainbowKey: 'First-time Payer',
                        type: 'int',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_pay_amount',
                        reqMetricKey: 'new_pay_amount',
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enWidth: 320,
                        cnWidth: 320,
                        enName: 'Revenue(first-time payer)',
                        cnName: '首次付费用户金额',
                        rainbowKey: 'Revenue(first-time payer)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_arppu',
                        reqMetricKey: 'new_arppu',
                        enPercentWidth: 230,
                        cnPercentWidth: 230,
                        enWidth: 286,
                        cnWidth: 286,
                        enName: 'First-time Payer ARPPU($)',
                        cnName: '首次付费用户ARPPU($)',
                        rainbowKey: 'First-time Payer ARPPU($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'new_user_arpu',
                        reqMetricKey: 'new_user_arpu',
                        enPercentWidth: 230,
                        cnPercentWidth: 230,
                        enWidth: 260,
                        cnWidth: 260,
                        rainbowKey: 'New User ARPU($)',
                        enName: 'New User ARPU($)',
                        cnName: '新进用户付费ARPU($)',
                        type: 'decimals',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      },
                      {
                        metricKey: 'total_pay_days',
                        reqMetricKey: 'total_pay_days',
                        enPercentWidth: 160,
                        cnPercentWidth: 160,
                        enWidth: 195,
                        cnWidth: 195,
                        enName: 'Total Pay Days',
                        cnName: '总付费天数',
                        rainbowKey: 'Total Pay Days',
                        type: 'int',
                        decimal: 2,
                        percentDecimals: 1,
                        percentDecimalsFloating: true
                      }
                    ]
                  }
                }
              }
            }
          ]
        }
      ]
    }
  ]
};
